'use client';
import EventEmitter from 'events';
import { useEffect } from 'react';
var RNEvents = new EventEmitter();
export var registerRNHandler = function (action, callback) {
    RNEvents.on(action, callback);
    return function () { return RNEvents.off(action, callback); };
};
export var useRNHandler = function (action, callback) {
    useEffect(function () {
        var deregister = registerRNHandler(action, callback);
        return function () { return deregister(); };
    }, [action, callback]);
};
var onMessageFromRN = function (message) {
    var _a = JSON.parse(message), action = _a.action, payload = _a.payload;
    RNEvents.emit(action, payload);
};
export var sendMessageToRN = function (message) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
};
export default function useListenFromRn() {
    useEffect(function () {
        window.onMessageFromRN = onMessageFromRN;
    }, []);
    return {
        sendMessageToRN: sendMessageToRN,
        useRNHandler: useRNHandler,
        registerRNHandler: registerRNHandler
    };
}
